<script lang="ts">
  import { syncZoom } from '#lib/icons/index.js';
  import { syncTimeRange$ } from '#lib/timeRange.js';
  import Fa from 'svelte-fa';
</script>

<label
  title="Sync X range across charts"
  class="bg-base-100/40 flex items-center gap-2 rounded-full p-0.5"
>
  <input type="checkbox" class="toggle toggle-primary toggle-lg" bind:checked={$syncTimeRange$} />
  <Fa icon={syncZoom} class="mr-2" />
</label>
